<template>
  <el-row class="cs-contentContainer">
    <el-col :span="4" class="cs-main-left-container">
      <navigator></navigator>
    </el-col>
    <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
      <div style="" class="cs-fullHeight cs-contentContainer-right">
        <div class="backgroud-white cs-fullHeight cs-landing-container">
          <div class="cs-landing-top">
            <div class="cs-landing-top-title">
              <span>人生最大的喜悦是每个人都说你做不到，你却完成了</span>
            </div>
            <el-row>
              <el-col :span="12">
                <div>
                  <div class="cs-landing-top-item">
                    <span class="cs-landing-top-number">620,000 +</span>
                    <span class="cs-landing-top-desc">服务人数</span>
                  </div>
                  <div class="cs-landing-top-item">
                    <span class="cs-landing-top-number">45,000 +</span>
                    <span class="cs-landing-top-desc">高分毕业人数</span>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <div class="cs-landing-top-item">
                    <span class="cs-landing-top-number">80,000 +</span>
                    <span class="cs-landing-top-desc">累计教学小时数</span>
                  </div>
                  <div class="cs-landing-top-item">
                    <span class="cs-landing-top-number">1,430,000 +</span>
                    <span class="cs-landing-top-desc">官方视频平台</span>
                    <span class="cs-landing-top-desc">累计观看人数</span>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="cs-landing-desc-section cs-landing-section">
            <img class="cs-landing-desc-icon" src="../assets/studentLanding/landing_logo.png" />
            <artisticalLabel labelText="关于速成" />
            <div class="cs-landing-desc-text">
              <span>北美华人教育学校，独创留学后期一站式良性生态闭环，覆盖整个求学生涯，从落地到升学，从毕业到求职，致力于为每一位海外学子提供着全方位、全覆盖的跟踪式服务。速成教育总部坐落于加拿大温哥华，过百人的资深教职团队，极丰富的海外教育经验，数万平方尺的占地面积，每年破万的学生人数，奠定了速成在北美教育领域首屈一指的地位。</span>
            </div>
          </div>
          <div class="cs-landing-videos-section cs-landing-section">
            <div class="cs-landing-section-title">
              <artisticalLabel :backgroundText="universityName" labelText="校区精选视频" />
              <el-select v-model="universityId" size="small" placeholder="请选择校区" @change="onUniversityChange">
                <el-option v-for="(item, index) in universityList" :key="index" :label="item.key" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="cs-landing-videos-container">
              <div class="cs-landing-video-item" v-for="(item, index) in videoList" :key="index">
                <div class="cs-landing-video" v-html="getVideoSrc(item)"></div>
                <div class="cs-landing-video-actions">
                  <div class="cs-landing-video-actions-left">
                    <span class="cs-landing-video-course">{{
                      item.course
                    }}</span>
                    <span class="cs-landing-video-teacher">主讲人:{{ item.teacher }}</span>
                  </div>
                  <div class="cs-landing-video-actions-right">
                    <el-button type="primary" size="mini" @click="onVideoClick(item)">免费试听</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cs-landing-courses-section">
            <coursesView :dataIn="dataForComponents.courseView" />
          </div>
          <div class="cs-landing-images-section cs-landing-section">
            <myUniversity :dataIn="dataForComponents.myUniversity" />
          </div>
          <div class="cs-landing-teachers-section cs-landing-section">
            <artisticalLabel :backgroundText="universityName" labelText="我的专属导师" />
            <div class="cs-landing-teachers-container">
              <div class="cs-landing-teacher-item" v-for="(item, index) in teacherList" :key="index">
                <el-avatar class="cs-landing-teacher-img" :src="require(`@/assets/studentLanding/${universityName}/${universityName}老师_${item.name}.png`)"
                  @error="errorHandler">
                </el-avatar>
                <div class="cs-landing-teacher-desc">
                  <el-popover placement="bottom" width="610" trigger="click">
                    <el-row class="cs-landing-teacherDetail">
                      <el-col :span="8">
                        <div class="cs-landing-teacher-desc">
                          <span class="cs-landing-teacher-name">{{
                            currentTeacher.name
                          }}</span>
                          <span class="cs-landing-teacher-title">{{
                            currentTeacher.title
                          }}</span>
                        </div>
                      </el-col>
                      <el-col :span="16">
                        <div class="cs-landing-teacher-description" v-html="currentTeacher.description"></div>
                      </el-col>
                    </el-row>
                    <template #reference>
                      <span class="cs-landing-teacher-name" @click="onTeacherClick(item)">{{ item.name }}</span>
                    </template>
                  </el-popover>
                  <span class="cs-landing-teacher-title">{{ item.title }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog v-if="videoViewVisible" title="免费试听" :center="true" :close-on-click-modal="false" :visible.sync="videoViewVisible" top="8vh" width="630px">
        <div v-html="videoPath"></div>
      </el-dialog>
      <el-dialog :visible.sync="ad.adVisible" :center="true" :close-on-click-modal="false" top="60px" :width="currentImageWidth"
        :class="{'cs-ad-dialogDefault': isAdDefault}" custom-class="cs-ad-dialog">
        <el-carousel v-loading="isLoadingImage" :interval="10000" arrow="always" ref="adCarousel" @change="onImageChange" height="600px">
          <el-carousel-item v-for="(item, index) in ad.images" :key="item.src" :name="item.name">
            <!-- <div class="carousel-content" 
              v-bind:style="{'width': '100%', 'height': '100%', 'background': 'url(\'' + item.src + '\') no-repeat', 'background-position': 'center center', 'background-size': 'cover' }">
              <a v-bind:href="item.link || 'javascript:void(0);'" v-bind:target="item.link ? '_blank' : '_self'">&nbsp;</a>
            </div> -->
            <img :src="item.src" lazy @click="onAdImgClick(item.link)" @load="onImgLoad($event, item.id, index)" />
          </el-carousel-item>
        </el-carousel>
      </el-dialog>
    </el-col>
  </el-row>
</template>

<style lang="scss">
body {
  .cs-ad-dialogDefault {
    .cs-ad-dialog {
      background-color: transparent;
    }
  }

  .cs-ad-dialog {
    margin: 0 auto;
    padding-bottom: 0;

    .el-dialog__body {
      padding: 0;
    }

    .el-dialog__headerbtn {
      top: 6px;
    }

    .el-carousel__item .cs-demo-image__lazy {
      position: relative;
    }

    .carousel-content > a {
      display: block;
      width: 100%;
      height: 100%;
    }

    .el-carousel__item {
      text-align: center;

      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: cover;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.cs-landing-container {
  font-family: "Microsoft YaHei", 微软雅黑, "MicrosoftJhengHei", 华文细黑,
    STHeiti, MingLiu;
  padding-bottom: 30px;
  .cs-landing-top {
    background-image: url(~@/assets/studentLanding/landing_background.jpg);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    color: white;
    text-align: center;

    .cs-landing-top-title {
      font-size: 48px;
      padding-top: 115px;
      padding-bottom: 115px;
    }

    .cs-landing-top-item {
      vertical-align: top;
      display: inline-block;
      padding-bottom: 10px;
      &:first-of-type {
        border-right: 2px solid;
        padding-right: 20px;
        margin-right: 20px;
      }
    }

    .cs-landing-top-number {
      font-size: 30px;
      display: block;
    }
    .cs-landing-top-desc {
      font-size: 12px;
      display: block;
    }
  }

  .cs-landing-section {
    padding-top: 100px;
    padding-left: 40px;
    padding-right: 40px;
    text-align: center;
  }

  .cs-landing-desc-section {
    background-image: url(~@/assets/studentLanding/landing_background_triangle.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    position: relative;

    .cs-landing-desc-icon {
      width: 100px;
      position: absolute;
      top: -50px;
      margin-left: -50px;
      left: 50%;
    }
    .cs-landing-desc-text {
      font-size: 14px;
      display: block;
      margin-top: 60px;
      padding: 0 120px;
    }
  }

  .cs-landing-section-title {
    text-align: center;

    .el-select {
      margin-left: 20px;
      vertical-align: middle;
    }

    .cs-artisticalLabel-container {
      vertical-align: middle;
    }
  }
  .cs-landing-videos-section {
  }

  .cs-landing-videos-container {
    padding: 20px 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 44px;

    .cs-landing-video-item {
      width: 240px;
      margin-right: 25px;
      margin-bottom: 30px;
      box-shadow: 5px 5px 5px #ced3d9;
      border-radius: 5px;

      .cs-landing-video {
        width: 100%;

        /deep/ iframe {
          width: 100%;
        }
      }

      .cs-landing-video-actions {
        padding: 10px;
        .cs-landing-video-actions-left {
          text-align: left;
          padding-left: 5px;
          .cs-landing-video-course {
            display: block;
            font-size: 19px;
            font-weight: bold;
            margin-bottom: 10px;
          }
          .cs-landing-video-teacher {
            display: block;
            font-size: 12px;
            color: grey;
          }
        }
        .cs-landing-video-actions-right {
          position: relative;
          .el-button {
            color: white;
            position: absolute;
            right: 0px;
            bottom: 0px;
          }
        }
      }
    }
  }

  .cs-landing-courses-section {
    padding: 0 40px;
  }

  .cs-landing-teachers-section {
    .cs-landing-teachers-container {
      padding: 20px 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      flex-wrap: wrap;
      margin-top: 60px;

      .cs-landing-teacher-item {
        width: 220px;
        margin-right: 25px;
        margin-bottom: 30px;

        .cs-landing-teacher-img {
          // background-image: url(~@/assets/studentLanding/teacher_background.png);
          // background-repeat: no-repeat;
          // background-size: 100% 100%;
          // -moz-background-size: 100% 100%;
          // position: relative;
          width: 100%;
          height: 220px;
          background-color: #3e4a46;

          /deep/ img {
            margin: auto;
            //height: 220px;
          }
        }
        .cs-landing-teacher-desc {
          margin-top: 10px;
          .cs-landing-teacher-name {
            cursor: pointer;
            font-size: 18px;
          }
          .cs-landing-teacher-title {
            font-size: 12px;
          }
        }
      }
    }
  }
}

.cs-landing-teacher-desc {
  .cs-landing-teacher-name {
    display: block;
    color: #409eff;
    font-weight: bold;
  }
  .cs-landing-teacher-title {
    display: block;
    color: grey;
  }
}

.cs-landing-teacherDetail {
  animation: fade-in-vertical 1.5s;
  -webkit-animation: fade-in-vertical 1.5s;
  padding: 20px;
  .cs-landing-teacher-desc {
    margin-right: 20px;
    display: inline-block;

    .cs-landing-teacher-name {
      font-size: 36px;
    }
    .cs-landing-teacher-title {
      font-size: 20px;
      margin-top: 10px;
    }
  }
  .cs-landing-teacher-description {
    display: inline-block;
    font-size: 20px;
    word-break: break-word;
  }
}

.cs-landing-courses {
  padding: 40px;
}

@media screen and (max-width: 1400px) {
  .cs-landing-container {
    .cs-landing-top {
      .cs-landing-top-title {
        font-size: 42px;
      }

      .cs-landing-top-number {
        font-size: 28px;
      }
    }

    .cs-landing-videos-container {
      .cs-landing-video-item {
        width: 200px;
      }
    }

    .cs-landing-teachers-section {
      .cs-landing-teachers-container {
        .cs-landing-teacher-item {
          width: 200px;
          .cs-landing-teacher-img {
            height: 200px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .cs-landing-container {
    .cs-landing-top {
      .cs-landing-top-title {
        font-size: 32px;
      }

      .cs-landing-top-number {
        font-size: 20px;
      }
    }
  }
}
</style>

<script>
import {
  universities,
  getVideoList,
  getTeacherList,
} from "../service/studentLanding.service";
import { getStore, isSafari } from "../config/mUtils";
import * as adService from "../service/studentAd.service";

export default {
  components: {
    navigator: () => import("../components/navigator"),
    artisticalLabel: () => import("../components/common/artisticalLabel"),
    coursesView: () => import("@/components/studentLanding/coursesView"),
    myUniversity: () => import("@/components/studentLanding/myUniversity"),
    imageShow: () => import("@/components/fileHandler/imageShow"),
  },
  data() {
    return {
      dataForComponents: {
        courseView: {
          university: 0,
        },
        myUniversity: {
          university: 0,
        },
      },
      universityList: [],
      videoList: [],
      teacherList: [],
      universityId: 0,
      videoViewVisible: false,
      videoPath: "",
      teacherDetailVisible: false,
      currentTeacher: {},
      ad: {
        adVisible: false,
        currentHeight: "0px",
        images: [],
      },
      imageSizes: [],
      currentImageWidth: "1000px",
      currentImageHeight: "600px",
      isAdDefault: true,
      isLoadingImage: false,
    };
  },
  created() {
    this.universityList = JSON.parse(JSON.stringify(universities.getOptions()));
    let studentUniversityName = getStore("user_student_universityAbbreviation");
    if (!!studentUniversityName) {
      studentUniversityName = studentUniversityName.toUpperCase();
      if (studentUniversityName == "FIC") {
        studentUniversityName = "SFU";
      }
    }

    let currentUniversity = this.universityList.find(
      (i) => studentUniversityName.indexOf(i.key) >= 0
    );
    if (!!currentUniversity) {
      currentUniversity.key = "当前校区(" + currentUniversity.key + ")";
    }

    this.universityId = !!currentUniversity ? currentUniversity.value : null;
    this.resetDataForComponents();

    this.reloadData();

    // //如果学生存在未签署的合同, 直接跳转到签约页面.
    // //没有的话弹对话框显示广告.
    // checkStudentHasUnsignedContracts().then((rs) => {

    // //不显示广告
    // if(rs.data) {
    //   location.href = "/pendingContracts";
    //   return;
    // }

    adService.queryCurrentStudentAds().then((ads) => {
      if (ads != null && ads.success && ads.data.length > 0) {
        this.isLoadingImage = true;
        this.ad.adVisible = true;
        //10秒后如果图片还未加载完成关闭loading
        setTimeout(() => {
          this.isLoadingImage = false;
        }, 10000);
        this.ad.images = ads.data.map((v, i, a) => {
          return {
            id: v.Id,
            src: v.PictureUrl,
            width: v.ImageWidth,
            height: v.ImageHeight,
            name: v.Name,
            comment: v.Comment,
            link: v.LinkUrl,
            loaded: false,
          };
        });
      } else {
        this.ad.adVisible = false;
      }
    });
  },
  computed: {
    universityName() {
      let universityItem = universities.valueOf(this.universityId);
      return !!universityItem ? universityItem.key : String.empty;
    },
  },
  methods: {
    resetDataForComponents() {
      this.dataForComponents.courseView = {
        university: this.universityId,
      };

      this.dataForComponents.myUniversity = {
        university: this.universityId,
      };
    },
    onUniversityChange() {
      this.reloadData();
      this.resetDataForComponents();
    },
    reloadData() {
      this.videoList = getVideoList(this.universityId);
      this.teacherList = getTeacherList(this.universityId);
    },
    getVideoSrc(item) {
      let video = $(item.video);
      let iframe = video.find("iframe");
      iframe.attr("style", "");
      return iframe.get(0).outerHTML;
    },
    onVideoClick(item) {
      this.videoPath = item.video;
      this.videoViewVisible = true;
    },
    onTeacherClick(item) {
      if (!!this.currentTeacher && item.name == this.currentTeacher.name) {
        this.teacherDetailVisible = !this.teacherDetailVisible;
      } else {
        if (!!this.currentTeacher) {
          this.teacherDetailVisible = false;
        }

        this.currentTeacher = item;
        this.teacherDetailVisible = true;
      }
    },
    errorHandler() {},
    onAdImgClick(href) {
      if (!href) {
        return;
      }
      let safari = isSafari();
      if (safari) {
        window.open(href, "_blank");
      } else {
        var link = document.createElement("a");
        link.href = href;
        link.target = "_blank";
        link.click();
        window.setTimeout(() => {
          //释放内存
          window.URL.revokeObjectURL(link.href);
        }, 1000);
      }
    },
    onContractSigned() {
      this.contract.dialogVisible = false;
    },
    onImgLoad(e, id, index) {
      let path = e.path ? e.path : e.composedPath();
      if (!path || path.length == 0) {
        return;
      }
      let img = path[0];
      if (img) {
        let imgData = this.ad.images.find((i) => i.id == id);
        if (imgData) {
          imgData.loaded = true;
        }
        let width = img.naturalWidth;
        let height = img.naturalHeight;
        let maxWidth = 1000;
        let maxHeight = 600;

        let imgWidth = maxWidth;
        let ratio = imgWidth / width;
        let imgHeight = parseInt(height * ratio);
        if (imgHeight > maxHeight) {
          imgHeight = maxHeight;
          ratio = imgHeight / height;
          imgWidth = parseInt(width * ratio);
        }
        this.imageSizes.push({ id: id, width: imgWidth, height: imgHeight });
        if (index == 0) {
          this.setImageSize(id);
        }
        let isLoadedAllIndex = this.ad.images.findIndex((i) => !i.loaded);
        if (isLoadedAllIndex < 0) {
          this.isAdDefault = false;
          this.isLoadingImage = false;
        }
      }
    },
    onImageChange(index) {
      if (index >= 0 && index < this.ad.images.length) {
        let id = this.ad.images[index].id;
        this.setImageSize(id);
      }
    },
    setImageSize(id) {
      let imgSize = this.imageSizes.find((i) => i.id == id);
      if (imgSize) {
        this.currentImageWidth = imgSize.width + "px";
        this.currentImageHeight = imgSize.height + "px";
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/page/studentLanding.vue